import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <rect x='5' width='4.55697' height='4.55697' rx='2.27848' />
            <rect x='5' y='9.72168' width='4.55697' height='4.55697' rx='2.27848' />
            <rect x='5' y='19.4431' width='4.55697' height='4.55697' rx='2.27848' />
            <rect x='15.1265' width='4.55697' height='4.55697' rx='2.27848' />
            <rect x='15.1265' y='9.72168' width='4.55697' height='4.55697' rx='2.27848' />
            <rect x='15.1265' y='19.4431' width='4.55697' height='4.55697' rx='2.27848' />
        </SvgIcon>
    );
});
